<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #EDEFF2',
    }"
  >
    <!-- 题目类型标签 -->
    <div class="question-type">图片/视频</div>

    <!-- 题目标题 -->
    <div class="title-view">
      <!-- <span style="color: #4c4a56">
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">{{ dataObj.caseProblem }}</span>
      </span> -->
      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>

    <!-- 题目封面图片列表 -->
    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" style="width: 100%; border-radius: 6px" />
      </div>
    </div>

    <!-- 图片/视频内容列表 -->
    <div class="image-options">
      <div v-for="(option, index) in list" :key="index">
        <!-- 图片展示 -->
        <div
          v-if="option.type === 'image'"
          class="image-view"
          @click="showBigImage(option.url)"
        >
          <img :src="option.url" class="img" />
        </div>
        <!-- 视频展示 -->
        <div v-else class="image-view">
          <video
            :src="option.url"
            style="width: 100%; height: 200px"
            controls
          ></video>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗（替代小程序自定义弹窗） -->
    <el-dialog
      title="图片预览"
      :visible.sync="fangdaShow"
      width="60%"
      @close="fangdaClose"
      append-to-body
    >
      <div class="popup-scroll">
        <img :src="fangdaImgUrl" style="width: 100%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QuestionMediaView",
  // Vue2 定义Props
  props: {
    params: {
      type: Object,
      default: () => ({}), // 对象默认值用函数避免引用共享
    },
  },
  data() {
    return {
      dataObj: {},
      answerObj: {},
      index: 0,
      list: [],
      count: 3,
      isMultiple: true,
      startColor: { r: 58, g: 96, b: 255 },
      endColor: { r: 58, g: 96, b: 255 },
      themeColor: { r: 58, g: 96, b: 255 },
      images: [],
      rules: [],
      // 替代 Vue3 ref
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
    };
  },
  // Vue2 监听属性
  watch: {
    // 监听props.dataObj变化（保留immediate和deep）
    params: {
      handler(newValue) {
        this.dataObj = { ...newValue.data }; // 深拷贝避免引用问题
        this.index = newValue.index || 0;
        // 解析图片列表（容错：空值时解析为空数组）
        this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
        // 解析图片/视频内容列表（容错）
        this.list = JSON.parse(newValue.data.chooseList || '{"list":[]}').list;
      },
      immediate: true, // 初始化立即执行
      deep: true, // 深度监听对象变化
    },
  },
  methods: {
    showBigImage(url) {
      this.fangdaShow = true;
      this.fangdaImgUrl = url;
    },
    // 关闭预览弹窗
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
  },
};
</script>

<style lang="scss" scoped>
// 核心容器样式
.question-container {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 15px;
  box-sizing: border-box;
}

// 题目封面图片区域
.question-images {
  margin-bottom: 10px;

  img {
    max-width: 100%;
    border-radius: 6px;
  }
}

// 图片/视频列表容器
.image-options {
  margin-bottom: 10px;
}

// 图片/视频展示项
.image-view {
  width: 100%;
  background: #f4f4f4;
  border-radius: 6.5px; // 13rpx → 6.5px
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  margin-top: 10px; // 20rpx → 10px

  .img {
    width: 100%;
    height: 100%;
    object-fit: cover; // Web端添加适配
  }

  video {
    outline: none; // 去掉视频控件焦点框
  }
}

// 以下为原代码中未用到的样式（保留但适配px）
.content-box {
  width: 160px; // 320rpx → 160px
  padding: 6.5px 10px; // 13rpx 20rpx → 6.5px 10px
  box-sizing: border-box;
  border: 1px dashed #3a60ff; // 2rpx → 1px
  border-radius: 4px; // 8rpx → 4px
  margin-top: 10px; // 20rpx → 10px

  input {
    width: 100%;
    font-size: 14px; // 28rpx → 14px
    color: #2b2f36;
    border: none;
    outline: none;
  }

  textarea {
    width: 100%;
    font-size: 14px; // 28rpx → 14px
    color: #2b2f36;
    line-height: 20px; // 40rpx → 20px
    height: 60px; // 120rpx → 60px
    resize: none;
    border: none;
    outline: none;
  }
}

// 预览弹窗内容
.popup-scroll {
  width: 100%;
  padding: 10px;

  img {
    max-width: 100%;
    max-height: 600px; // Web端限制最大高度
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationPreview/EvaluationPreviewImageOrVideo.vue